import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import { brand_channel_fields } from "../data";
import RenderInputField from "components/MboPaymentWorking/CommonComponents/RenderInputFiled/RenderInputFiled";

function BrandChannel({ value, setValue }) {
	return (
		<Box p={0} width={"100%"}>
			<Box display="flex" flexWrap="wrap" columnGap={1} pl={2}>
				{brand_channel_fields?.map((row) => {
					return (
						<RenderInputField
							column={row}
							data={value}
							setData={setValue}
							width="45%"
							selectOptObjName={"option_data"}
							key={row.key}
						/>
					);
				})}
			</Box>
		</Box>
	);
}

export default BrandChannel;
